import { Constants } from "../Constants";
import BaseApi from "./BaseApi";

class IdentityUserApi extends BaseApi {
  constructor() {
    super(
      process.env.REACT_APP_baseAuthUrl,
      Constants.USER_TOKEN_KEY,
      Constants.USER_TOKEN_EXPIRATION
    );
    this.getUserInfo = this.getUserInfo.bind(this);
    this.isEmailConfirmed = this.isEmailConfirmed.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }

  //Didn't work for shit out of the box. Has to be extended and that's a bitch. Leaving this here in case I want to abuse myself anymore over something so fuckin stupid.
  async getUserInfo() {
    const response = await this.getAxios().get("/api/users/");
    return response;
  }

  async isEmailConfirmed() {
    try {
      const response = await this.getAxios().get(
        "/api/account/isemailconfirmed",
        this.jsonEncoded
      );
      return response.data;
    } catch (err) {
      //not good
      //need to notify us about this

      return false;
    }
  }

  isAuthenticated() {
    const token = this.getCurrentValidToken(
      Constants.USER_TOKEN_KEY,
      Constants.USER_TOKEN_EXPIRATION
    );
    return token ? true : false;
  }

  async changeUsername(userName) {
    //this.errorManager.reset();
    try {
      const params = {
        params: { userName, applicationContext: "safefun-verifier" },
      };
      const response = await this.getAxios().get(
        "/api/account/changeusername",
        params,
        this.jsonEncoded
      );
      window.localStorage.setItem(Constants.USERNAME_KEY, userName);
      return response.data;
    } catch (err) {
      console.log(err);
      return false;
    }
  }

  async changePassword(currentPassword, newPassword) {
    const params = {
      params: {
        currentPassword,
        newPassword,
        applicationContext: "safefun-verifier",
      },
    };
    const response = await this.getAxios().get(
      "/api/account/changepasswordusingcurrent",
      params,
      this.formEncoded
    );
    return response.data;
  }
  catch(err) {
    console.log(err);
    return false;
  }
}
export default IdentityUserApi;
